import { LANGUAGES, UBI_CONNECT } from '../../utils/constants';
import { Modal, ModalBody } from 'react-bootstrap';

import { selectLocalSettings } from '../../ducks/settings';
import { useSelector } from 'react-redux';

interface Props {
  open: boolean;
  onClose: () => void;
}

const LoginModal = (props: Props) => {
  const languageLocal = useSelector(selectLocalSettings);

  const src = `${UBI_CONNECT.baseURL}/login?appId=${
    UBI_CONNECT.appId
  }&genomeId=${UBI_CONNECT.genomeId}&lang=${
    languageLocal || LANGUAGES[0].locale
  }&nextUrl=${encodeURIComponent(UBI_CONNECT.nextURL)}`;

  return (
    <Modal
      show={props.open}
      onHide={props.onClose}
      backdrop="static"
      keyboard={false}
      className="modal--login"
    >
      <Modal.Header closeButton />
      <ModalBody>
        <div className="iframe-wrapper">
          <iframe title="Uplay login modal" src={src} frameBorder="0" />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default LoginModal;
